module.exports = __webpack_public_path__ + "static/media/background-convert.b07c9b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Static/background-convert.jpg
// module id = 1328
// module chunks = 0